import React, { useEffect } from 'react';

const Unauthorized = () => {
    
  useEffect(() => {
    sessionStorage.clear();
   });
   
    return (
      <div style={{textAlign:'center',paddingTop:'35vh'}}>
        <h1 className='title'>UnAuthorized!</h1>
        <p>
        To request access, please reach out to:
        </p>
        <p>Eltham Liu(dengpan.liu@se.com)</p>
      </div>
    );
};
export default Unauthorized;